import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import HelpDocument from '../../models/helpDocument';
import HelpContent from '../help/help-content';
import { Scrollbars } from 'react-custom-scrollbars';
import * as reportStyles from './report.module.scss';

interface Props {
  open: boolean;
  allDocuments: HelpDocument[];
  onClose: (open: boolean) => void;
}

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  container: {
    backgroundColor: 'white',
    borderRadius: '3px',
    boxShadow: '0 2px 2px 2px rgba(0, 0, 0, 0.7)',
    height: 'min-content',
    minHeight: 249,
    maxHeight: '80%',
    outline: 'none',
    overflow: 'auto',
    padding: '20px',
    width: '80%',
    minWidth: 576,
    maxWidth: 1300,
    margin: 'auto'
  }
};

/**
 * @function AltTextModal - Modal to show alternative text for help documents
 */
const AltTextModal = ({ open, onClose, allDocuments }: Props) => {
  return (
    <Modal style={styles.modal} open={open} onClose={(isOpen: boolean) => onClose(!isOpen)}>
      <div className="altModal" style={styles.container}>
        <Scrollbars className={reportStyles.altTextScrolling}>
          {allDocuments.length > 0 &&
            allDocuments.map((doc, index) => (
              <HelpContent key={`alt-text-${index}`} document={doc} activeDoc={0} showAltText={true} />
            ))}
        </Scrollbars>
      </div>
    </Modal>
  );
};

export default AltTextModal;
